module.exports = "/packs/images/homepage/facilities/covid_booking~59b1da4f6f14f185b5cd21fc684485b8.jpg";